import React from 'react';
import {
  Row, Col, Form, Select, Typography, Input,
} from 'antd';
import CurrencyInput from 'react-currency-input';
import PropTypes from 'prop-types';
import { getUserType } from '../../../../../utils/users';
import './DetailsFields.scss';

const Details = (props) => {
  const {
    initialValuesObject, edit, detail,
  } = props;

  const listOrderType = [
    'Interna',
    'Externa',
  ];

  return (
    <Row
      gutter={24}
      className="inline-field"
    >
      <Col span={24}>
        {
          getUserType() === 'COOPERCITRUS' && !detail
            ? (
              <>
                <Form.Item
                  name={'POS_VENDA_MONTAGEM_DE_EQUIPAMENTO_TIPO_ORDEM'}
                  rules={[
                    {
                      required: true,
                      message: 'O campo é obrigatório',
                    },
                  ]}
                  label={(
                    <span
                      className="MontagemEquipamentoDetails__PRNTCalcarioTitle MontagemEquipamentoDetails__AllFormLabels"
                    >
                      Tipo de ordem
                    </span>
                  )}
                  initialValue={initialValuesObject?.['POS_VENDA_MONTAGEM_DE_EQUIPAMENTO_TIPO_ORDEM'] || undefined}
                >
                  <Select disabled={edit} className="MontagemEquipamentoDetails__GridSizeSelect">
                    {
                      listOrderType.map((_item) => (
                        <Select.Option key={_item} value={_item}>
                          {_item}
                        </Select.Option>
                      ))
                    }
                  </Select>
                </Form.Item>

                <Row gutter={[24, 24]}>
                  <Col xs={{ span: 24 }}>
                    <hr />
                    <p className="MontagemEquipamentoDetails__SessionTitle">Orçamento</p>
                  </Col>
                </Row>

                <Row
                  gutter={[24, 24]}
                  className="MontagemEquipamentoDetails__GridSizeRow"
                >
                  <Col
                    xs={{ span: 24 }}
                    className="MontagemEquipamentoDetails__GridSizeColumn"
                  >
                    <Form.Item
                      label={(
                        <Typography.Title
                          level={5}
                          className="MontagemEquipamentoDetails__GridSizeTitle MontagemEquipamentoDetails__AllFormLabels"
                        >
                          Valor unitário
                        </Typography.Title>
                      )}
                      name="POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_UNITARIO"
                      className="MontagemEquipamentoDetails__GridSizeFormItem"
                      rules={[
                        {
                          validator: (rule, value) => {
                            if (value < 0) {
                              return Promise.reject(new Error('Deve ser um numero maior que zero'));
                            }

                            return Promise.resolve();
                          },
                        },
                      ]}
                      initialValue={
                        (
                          initialValuesObject?.['POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_UNITARIO']
                            ? initialValuesObject['POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_UNITARIO'].replaceAll('.', ',')
                            : '0,00'
                        )
                      }
                    >
                      <CurrencyInput
                        allowEmpty="true"
                        className="ant-input"
                        decimalSeparator=","
                        thousandSeparator="."
                        placeholder="0,00"
                        step={0.01}
                        min={0}
                        disabled={edit}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row
                  gutter={[24, 24]}
                  className="MontagemEquipamentoDetails__GridSizeRow"
                >
                  <Col
                    xs={{ span: 24 }}
                    className="MontagemEquipamentoDetails__GridSizeColumn"
                  >
                    <Form.Item
                      label={(
                        <Typography.Title
                          level={5}
                          className="MontagemEquipamentoDetails__GridSizeTitle MontagemEquipamentoDetails__AllFormLabels"
                        >
                          Valor total
                        </Typography.Title>
                      )}
                      name="POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_TOTAL"
                      className="MontagemEquipamentoDetails__GridSizeFormItem"
                      rules={[
                        {
                          validator: (rule, value) => {
                            if (value < 0) {
                              return Promise.reject(new Error('Deve ser um numero maior que zero'));
                            }

                            return Promise.resolve();
                          },
                        },
                      ]}
                      initialValue={
                        (
                          initialValuesObject?.['POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_TOTAL']
                            ? initialValuesObject['POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_TOTAL'].replaceAll('.', ',')
                            : '0,00'
                        )
                      }
                    >
                      <CurrencyInput
                        allowEmpty="true"
                        className="ant-input"
                        decimalSeparator=","
                        thousandSeparator="."
                        placeholder="0,00"
                        step={0.01}
                        min={0}
                        disabled={edit}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row
                  gutter={[24, 24]}
                  className="MontagemEquipamentoDetails__GridSizeRow"
                >
                  <Col
                    xs={{ span: 24 }}
                    className="MontagemEquipamentoDetails__GridSizeColumn"
                  >
                    <Form.Item
                      label={(
                        <Typography.Title
                          level={5}
                          className="MontagemEquipamentoDetails__GridSizeTitle MontagemEquipamentoDetails__AllFormLabels"
                        >
                          Condição de pagamento
                        </Typography.Title>
                      )}
                      name="POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-CONDICAO_PAGAMENTO"
                      className="MontagemEquipamentoDetails__GridSizeFormItem"
                      rules={[
                        { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                      ]}
                      initialValue={initialValuesObject?.['POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-CONDICAO_PAGAMENTO']}
                    >
                      <Input
                        style={{ width: '100%' }}
                        disabled={edit}
                        maxLength="255"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row
                  gutter={[24, 24]}
                  className="MontagemEquipamentoDetails__GridSizeRow"
                >
                  <Col
                    xs={{ span: 24 }}
                    className="MontagemEquipamentoDetails__GridSizeColumn"
                  >
                    <Form.Item
                      label={(
                        <Typography.Title
                          level={5}
                          className="MontagemEquipamentoDetails__GridSizeTitle MontagemEquipamentoDetails__AllFormLabels"
                        >
                          Forma de pagamento
                        </Typography.Title>
                      )}
                      name="POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-FORMA_PAGAMENTO"
                      className="MontagemEquipamentoDetails__GridSizeFormItem"
                      rules={[
                        { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                      ]}
                      initialValue={initialValuesObject?.['POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-FORMA_PAGAMENTO']}
                    >
                      <Input
                        style={{ width: '100%' }}
                        disabled={edit}
                        maxLength="255"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row
                  gutter={[24, 24]}
                  className="MontagemEquipamentoDetails__GridSizeRow"
                >
                  <Col
                    xs={{ span: 24 }}
                    className="MontagemEquipamentoDetails__GridSizeColumn"
                  >
                    <Form.Item
                      label={(
                        <Typography.Title
                          level={5}
                          className="MontagemEquipamentoDetails__GridSizeTitle MontagemEquipamentoDetails__AllFormLabels"
                        >
                          Observações do orçamento
                        </Typography.Title>
                      )}
                      name="POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-OBSERVACOES"
                      className="MontagemEquipamentoDetails__GridSizeFormItem"
                      rules={[
                        { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                      ]}
                      initialValue={initialValuesObject?.['POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-OBSERVACOES']}
                    >
                      <Input
                        style={{ width: '100%' }}
                        disabled={edit}
                        maxLength="255"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )
            : null
        }
      </Col>
    </Row>
  );
};

Details.propTypes = {
  formInstance: PropTypes.shape({
    getFieldValue: PropTypes.func.isRequired,
    validateFields: PropTypes.func.isRequired,
  }).isRequired,

  mode: PropTypes.oneOf(['CREATE', 'EDIT']).isRequired,

  initialValuesObject: PropTypes.shape({
    POS_VENDA_MONTAGEM_DE_EQUIPAMENTO_TIPO_ORDEM: PropTypes.string,
    'POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_UNITARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-VALOR_TOTAL': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-CONDICAO_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-FORMA_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'POS_VENDA_MONTAGEM_DE_EQUIPAMENTO-OBSERVACOES': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  edit: PropTypes.bool,
  detail: PropTypes.bool,
};
Details.defaultProps = {
  detail: false,
};

export default Details;
